<ui-modal
  class="credit-curves-modal"
  [isOpened]="showCreditCurves"
  modalTitle="Credit Curves"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="credit-curves">
    <div class="credit-curves__tables-container">
      <div class="credit-curves__table-info-group-container">
        <div class="credit-curves__table-info">
          <form [formGroup]="creditCurvesForm">
            <div #divToScrollCurves class="table-container">
              <table ui-table>
                <thead>
                  <tr>
                    <th class="entity">Entity</th>
                    <th class="currency">Currency</th>
                    <th class="cds-recovery-rate">CDS Recovery Rate</th>
                    <th class="cerivative-recovery-rate">
                      Derivative Recovery Rate
                    </th>
                    <th class="spread-day-count-convention">
                      Spread Day Count Convention
                    </th>

                    <th class="spread-frequency">Spread Frequency</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container formArrayName="curves">
                    <tr
                      tabindex="0"
                      *ngFor="let item of curvesArray.controls; let i = index"
                      (click)="
                        selectedCurveIndex = i; selectedTenorIndex = null
                      "
                      [ngClass]="{ 'selected-row': selectedCurveIndex === i }"
                    >
                      <ng-container [formGroupName]="i">
                        <td>
                          <select formControlName="entity">
                            <option
                              *ngFor="let item of identifiers"
                              [value]="item"
                            >
                              {{ item }}
                            </option>
                          </select>
                        </td>

                        <td>
                          <input
                            type="text"
                            class="input-cell"
                            formControlName="currency"
                            [inputValidator]="['currency']"
                          />
                        </td>

                        <td>
                          <input
                            type="text"
                            class="input-cell"
                            formControlName="cdsRecoveryRate"
                            [inputValidator]="['percentage']"
                            (click)="
                              textBoxCaretRestrictionHandler($event, 'click')
                            "
                            (keydown)="
                              textBoxCaretRestrictionHandler($event, 'keydown')
                            "
                            (focus)="selectedPercentField = $event.target"
                          />
                        </td>

                        <td>
                          <input
                            type="text"
                            class="input-cell"
                            formControlName="derivativeRecoveryRate"
                            [inputValidator]="['percentage']"
                            (click)="
                              textBoxCaretRestrictionHandler($event, 'click')
                            "
                            (keydown)="
                              textBoxCaretRestrictionHandler($event, 'keydown')
                            "
                            (focus)="selectedPercentField = $event.target"
                          />
                        </td>

                        <td>
                          <select formControlName="spreadDayCountConvention">
                            <option value="Act/360">Act/360</option>
                            <option value="Act/365">Act/365</option>
                          </select>
                        </td>

                        <td>
                          <select formControlName="spreadFrequency">
                            <option value="3m">3m</option>
                            <option value="6m">6m</option>
                          </select>
                        </td>
                      </ng-container>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </form>
          <div class="bottom-table-add">
            <div *ngIf="!loadingCurves; else EntitiesLoading">
              <span class="add-text-container"
                ><label class="add-text-container__add">+</label>
                <label
                  class="add-text-container__add-text"
                  (click)="addNewCurve()"
                  >Add Credit Curves</label
                ></span
              >
            </div>
            <ng-template #EntitiesLoading>
              <span class="add-text-container">
                <label
                  class="
                    add-text-container__add-text add-text-container__loading
                  "
                  >Loading</label
                ></span
              >
            </ng-template>
          </div>
        </div>
        <div class="credit-curves__table-spread-tenor__footer">
          <button
            class="
              ui-button ui-button__header ui-button--danger ui-button--delete
            "
            [disabled]="selectedCurveIndex === null"
            (click)="deleteCurve()"
          >
            Delete
          </button>
        </div>
      </div>

      <div class="credit-curves__table-spread-tenor__group-container">
        <div class="credit-curves__table-spread-tenor">
          <form [formGroup]="creditCurvesForm">
            <div #divToScrollTenors class="table-container">
              <table ui-table>
                <thead>
                  <tr>
                    <th class="tenor">Tenor</th>
                    <th class="spread">Spread</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container
                    *ngIf="this.selectedCurveIndex !== null"
                    formArrayName="curves"
                  >
                    <ng-container [formGroupName]="selectedCurveIndex">
                      <tr
                        tabindex="0"
                        *ngFor="
                          let item of tenorSpreadArray('spreads')['controls'];
                          let i = index
                        "
                        (click)="selectedTenorIndex = i"
                        [ngClass]="{ 'selected-row': selectedTenorIndex === i }"
                      >
                        <ng-container formArrayName="tenors">
                          <td>
                            <input
                              type="text"
                              class="input-cell"
                              [formControlName]="i"
                              [placeholder]="'#' + (i + 1)"
                              [inputValidator]="['tenor']"
                            />
                          </td>
                        </ng-container>
                        <ng-container formArrayName="spreads">
                          <td>
                            <input
                              type="text"
                              class="input-cell"
                              [formControlName]="i"
                              [inputValidator]="['percentage']"
                              (click)="
                                textBoxCaretRestrictionHandler($event, 'click')
                              "
                              (keydown)="
                                textBoxCaretRestrictionHandler(
                                  $event,
                                  'keydown'
                                )
                              "
                              (focus)="selectedPercentField = $event.target"
                            />
                          </td>
                        </ng-container>
                      </tr>
                    </ng-container>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </form>
          <div class="bottom-table-add">
            <div>
              <span
                class="add-text-container"
                [ngClass]="{ disabled: selectedCurveIndex === null }"
                ><label class="add-text-container__add">+</label>
                <label
                  class="add-text-container__add-text"
                  (click)="addNewSpreadTenor()"
                  >Add Tenor</label
                ></span
              >
            </div>
          </div>
        </div>
        <div class="credit-curves__table-spread-tenor__footer">
          <button
            class="
              ui-button ui-button__header ui-button--danger ui-button--delete
            "
            [disabled]="selectedTenorIndex === null"
            (click)="deleteTenor()"
          >
            Delete
          </button>
        </div>
      </div>
    </div>

    <div class="credit-curves__footer">
      <button
        class="ui-button primary"
        [disabled]="!allowedToSave"
        (click)="saveChanges()"
      >
        <ng-container [ngSwitch]="savingCurvesStatus">
          <span *ngSwitchCase="''"> Save </span>
          <span
            *ngSwitchCase="'LOADING'"
            class="spinner spinner-sm spinner-inverse"
          >
          </span>
          <span *ngSwitchCase="'DONE'"> Saved </span>
          <span *ngSwitchCase="'ERROR'"> Error </span>
        </ng-container>
      </button>
    </div>
  </div>
</ui-modal>
